// extracted by mini-css-extract-plugin
module.exports = {"filterGroup":"style_filterGroup__2yD_M","label":"style_label__1L6rX"};